import React from "react";
import CustomTabsGrid from "components/CustomTabs/CustomTabsGrid.js";
import Bchoatdongvantai from "components/Tonghopbaocao/Hoatdongvantai/Bchoatdongvantai.js";
import Phulucttdk from "components/Tonghopbaocao/Trungtamdangkiem/Phulucttdk.js";
export default function BCtonghop() {
  return (
    <div>
      <CustomTabsGrid
        headerColor="primary"
        tabs={[
          {
            tabName: "Hoạt động vận tải (Phụ lục XVII)",
            tabContent: <Bchoatdongvantai />,
          },
          {
            tabName: "Trung tâm đăng kiểm",
            tabContent: <Phulucttdk />,
          },
        ]}
      />
    </div>
  );
}
